import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero = () => {
  const words = ['farm', 'greenhouse', 'garden', 'field', 'orchard', 'vineyard'];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 4000); // Change word every 4 seconds

    return () => clearInterval(interval);
  }, [words.length]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <header className="hero">
      <div className="hero-content">
        <div className="hero-text">
          <h1>Your <span key={currentWordIndex} className="word-carousel">{words[currentWordIndex]}</span>,</h1>
          <p className="hero-subtitle">smarter</p>
          <p className="hero-description">Creating efficient drip irrigation technology for farmers worldwide</p>
          <button onClick={() => scrollToSection('contact')} className="btn btn-primary hero-btn">
            Join our Pilot →
          </button>
        </div>
      </div>
    </header>
  );
};

export default Hero;
